export const ordenarYFiltrarEdoCta = (estadosCta, role) => {
    const hoy = new Date();
  
    return estadosCta
      .filter((item) => {
        const [inicioStr, finStr] = item.month.split(" - ");
        const inicio = new Date(inicioStr);
        const fin = new Date(finStr);
  
        if (role === "Admin") {
          return true;
        }
  
        if (role === "Resident") {
          if (inicio > hoy) return false;
  
          const diasAntesPago = (inicio - hoy) / (1000 * 60 * 60 * 24);
          return diasAntesPago <= 3;
        }
  
        return false;
      })
      .sort((a, b) => {
        const [inicioA] = a.month.split(" - ");
        const [inicioB] = b.month.split(" - ");
        return new Date(inicioB) - new Date(inicioA);
      });
};